 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import React from 'react'
import useAtmosphere from '../hooks/useAtmosphere'
import useMutationProps from '../hooks/useMutationProps'
import UpdatePokerScopeMutation from '../mutations/UpdatePokerScopeMutation'
import {PALETTE} from '../styles/paletteV3'
import {Threshold} from '../types/constEnums'
import isTempId from '../utils/relay/isTempId'

import Checkbox from './Checkbox'
import Ellipsis from './Ellipsis/Ellipsis'

const Item = styled('div')({
  cursor: 'pointer',
  display: 'flex',
  paddingLeft: 16,
  paddingTop: 8,
  paddingBottom: 8
})

const Issue = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: 16
})

const Title = styled('div')({})

const StyledLink = styled('a')({
  color: PALETTE.SKY_500,
  display: 'block',
  fontSize: 12,
  lineHeight: '20px',
  textDecoration: 'none',
  '&:hover,:focus': {
    textDecoration: 'underline'
  }
})













const ScopingSearchResultItem = (props) => {
  const {
    meetingId,
    persistQuery,
    usedServiceTaskIds,
    summary,
    url,
    linkTitle,
    linkText,
    serviceTaskId,
    service
  } = props
  const isSelected = usedServiceTaskIds.has(serviceTaskId)
  const atmosphere = useAtmosphere()
  const {onCompleted, onError, submitMutation} = useMutationProps()
  const disabled = !isSelected && usedServiceTaskIds.size >= Threshold.MAX_POKER_STORIES
  const isTemp = isTempId(serviceTaskId)
  const onClick = () => {
    if (disabled || isTemp) return
    submitMutation()
    const variables = {
      meetingId,
      updates: [
        {
          service,
          serviceTaskId,
          action: isSelected ? 'DELETE' : 'ADD'
        }
      ]
    } 
    UpdatePokerScopeMutation(atmosphere, variables, {onError, onCompleted, contents: [summary]})
    if (!isSelected) {
      // if they are adding an item, then their search criteria must be good, so persist it
      _optionalChain([persistQuery, 'optionalCall', _ => _()])
    }
  }
  return (
    React.createElement(Item, { onClick: onClick,}
      , React.createElement(Checkbox, { active: isSelected || isTemp, disabled: disabled,} )
      , React.createElement(Issue, null
        , React.createElement(Title, null, summary)
        , React.createElement(StyledLink, { href: url, rel: "noopener noreferrer" , target: "_blank", title: linkTitle,}
          , linkText
          , isTemp && React.createElement(Ellipsis, null )
        )
      )
    )
  )
}

export default ScopingSearchResultItem
